<ion-content class="ion-padding">

    <audio #peerAudio></audio>

    <video #myVideo [hidden]="!isVideo" autoplay id="my-video"></video>
    <video #peerVideo [hidden]="!isVideo" autoplay id="peer-video"></video>

    <ion-grid *ngIf="!isVideo">
        <ion-row>
            <ion-col>
                <ion-text color="primary" >
                    <h3 class="ion-text-center">{{callName}}</h3>
                </ion-text>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col *ngIf="showAdressData">
                <adress-detail  [address]="patientDataProvider.activePatientData.addressData"></adress-detail>
            </ion-col>
            <ion-col *ngIf="!showAdressData" class="ion-text-center">
                <img alt="avatar" class="avatar" src="/assets/img/avatar.png"/>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <ion-text color="primary">
                    <h4 class="ion-text-center"></h4>
                </ion-text>
            </ion-col>
        </ion-row>
    </ion-grid>

    <ion-fab horizontal="center" slot="fixed" vertical="bottom">
        <ion-fab-button (click)="hangup()" class="hangupIcon" color="danger">
            <ion-icon name="call"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
